module.exports = __webpack_public_path__ + "img/part2-uIcon1.af5e9377.png";